import React, { useEffect, useRef, useState } from 'react';
import { attentionDashboardsRestCrudThunksForBuyer } from '../../thunks/attention_dashboard_thunks';
import {
	savedFilterViewsRestCrudThunksForBuyer,
	savedFilterViewsRestCrudThunksForSupplier,
} from '../../thunks/saved_filter_views_thunks';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { Button, Select } from 'antd';
import { compareStrings } from '../../utils/DataAccessUtils';

const DEFAULT_PAGE_LIMIT = 100;

const ViewSelection = ({ fetchSavedFilterViews, setSelectedView, selectedView }) => {
	const [loading, setLoading] = useState(true);
	const [showSelection, setShowSelection] = useState(false);
	const [views, setViews] = useState([]);
	const selector = useRef(null);

	useEffect(() => {
		setLoading(true);
		fetchSavedFilterViews(
			{},
			{},
			{
				current: 1,
				pageSize: DEFAULT_PAGE_LIMIT,
			},
			{
				sort_by: 'isPublic',
				order: 'ascend',
			},
			{}
		).then((result) => {
			setLoading(false);
			setViews(result.filter((view) => compareStrings(view.entityType, 'work_orders')));
		});
	}, []);

	return !loading && views.length > 0 ? (
		showSelection ? (
			<Select
				ref={selector}
				style={{
					width: 200,
				}}
				onChange={(viewId) => {
					setSelectedView(viewId && views.find(({ id }) => id === viewId));
					setShowSelection(false);
				}}
				value={selectedView && selectedView.id}
				placeholder={'Select a view'}
				allowClear={true}
				onClear={() => {
					setSelectedView(null);
					setShowSelection(false);
				}}
				open={true}
			>
				{views.map((view) => (
					<Select.Option key={view.id} value={view.id}>
						{view.name}
					</Select.Option>
				))}
			</Select>
		) : (
			<Button
				style={{ marginTop: -4, marginLeft: -12 }}
				type={'link'}
				onClick={() => {
					setShowSelection(true);
					if (selector.current) {
						selector.current.focus();
					}
				}}
			>
				<span style={{ fontSize: 16 }}>
					<i className="icons8-font icons8-filter" />
				</span>
			</Button>
		)
	) : null;
};

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
	attentionDashboard: state.attention_dashboards.detail,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	fetchSavedFilterViews: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? savedFilterViewsRestCrudThunksForSupplier.read(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
				: savedFilterViewsRestCrudThunksForBuyer.read(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
		),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(ViewSelection)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
